import { createRouter, createWebHistory } from 'vue-router'
import { currentOrder } from './order/order-state'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: ({ query }) => ({
      name: currentOrder.value && !query.number && !query.accessCode ? 'Order' : 'Login',
      query
    })
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('./login/LoginScreen'),
    props: ({ query: { number, accessCode } }) => ({ number, accessCode })
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('./order/OrderScreen')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: { name: 'Login' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active'
})

export default router
